import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import LanguageSwitch from 'src/components/LanguageSwitch/LanguageSwitch.vue';

const {
  title,
  lang,
} = getSsrState();

const app = createVueApp({
  render(h) {
    return h(LanguageSwitch, {
      props: {
        title,
        lang,
      }
    })
  },
});

app.$mount('[data-language-switch]');